import "./loader.scss";

const Loader = () => {
  return (
    <>
        <div className="loader-wrapper" role="status" aria-label="Loading page">
          <div className="loader">
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
          </div>
        </div>
    </>
  );
};

export default Loader;
